<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeSchemaComptable.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsSchemaComptable.maj) }"
               @click="$router.push({ name: 'm.parametrage.schema_comptable-add' })">
              {{ $t('listeSchemaComptable.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="schemaSelected.length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-5">
            <b-input :placeholder="$t('listeSchemaComptable.actions.search')"
                     type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" ref="tableSchemaComptable"
                    @loaded="finLoading" @loading="debutLoading">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableSchemaComptable.setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected">
        </b-checkbox>
      </div>
      <div slot="actif" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.actif" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="libelle" slot-scope="props">
        <router-link :to="{
        name: 'c.parametrage.schema_comptable', params: { id: props.row.id }}"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(permsSchemaComptable.lecture)}"
                     class="lien">
          {{ props.row.libelle }}
        </router-link>
      </div>
      <div slot="type" slot-scope="props">
        {{ $t(getLibelleType(props.row.type)) }}
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="$router.push({name: 'm.parametrage.schema_comptable-edit',
        params: { id: props.row.id }})">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsSchemaComptable.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsSchemaComptable.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsSchemaComptable.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsSchemaComptable.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsSchemaComptable.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="affFusion"
             has-modal-card
             class="modal">
      <app-fusion :schemas="schemaSelected" @close="closeAndRefresh" @fusion="fusion"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { fusionSchemaCemptableAsync } from '@/api/schemaComptable/index';
import messageErreur from '@/services/general/messageErreur';
import selecteurAction from '@/components/general/selecteurAction';
import inProgress from '@/services/general/inProgress';
import { SCHEMA_COMPTABLE } from '@/configuration/general/permissionsParametrageConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { LISTE_TYPE_SCHEMA_COMPTABLE, ACTION_FUSION } from '@/configuration/parametrage/schemaComptableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import appFusion from '@/components/parametrage/schemaComptable/p_fusion';

const permissions = createNamespacedHelpers('permissions');
const SchemaComptable = createNamespacedHelpers('schemaComptable');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: {},
      permsSchemaComptable: SCHEMA_COMPTABLE,
      unsubscribeValue: null,
      actions: [
        { action: ACTION_FUSION, translation: 'listeSchemaComptable.actions.fusion' },
      ],
      affFusion: false,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
    selecteurAction,
    appFusion,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeSchemaComptable.title'), route: { name: '' }, isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...SchemaComptable.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    schemaSelected() {
      return this.items.filter(i => i.selected);
    },
    iconSelectTotal() {
      if (this.allSchemaSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeSchemaComptable.tab.libelle'),
          type: this.$t('listeSchemaComptable.tab.type'),
          compteNormal: this.$t('listeSchemaComptable.tab.compteNormal'),
          edit: '',
          archive: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
          };
          return this.actionsLoadSchemaComptable(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          archive: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',

        },
        sortable: ['libelle', 'type', 'compteNormal'],
      };
    },
    columns() {
      return ['selected', 'libelle', 'type', 'compteNormal', 'edit', 'archive', 'delete'];
    },
    allSchemaSelected() {
      return this.items.length === this.schemaSelected.length && this.items.length > 0;
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...SchemaComptable.mapActions({
      actionsLoadSchemaComptable: 'loadSchemaComptable',
    }),
    selectAll() {
      const selected = !this.allSchemaSelected;
      this.items.forEach((item) => { item.selected = selected; });
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getLibelleType(type) {
      return LISTE_TYPE_SCHEMA_COMPTABLE.find((listeType) => {
        return type === listeType.code;
      }).libelle;
    },
    recherche() {
      this.$refs.tableSchemaComptable.refresh();
    },
    closeAndRefresh() {
      this.affFusion = false;
      this.recherche();
    },
    async fusion(idSelected) {
      this.debutLoading();
      try {
        const ids = this.schemaSelected.map(s => s.id);
        await fusionSchemaCemptableAsync(idSelected, ids);
        this.closeAndRefresh();
        this.finLoading();
      } catch (e) {
        this.finLoading();
        throw e;
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs.tableSchemaComptable.setPage(1);
    },
    handleAction(action) {
      switch (action) {
        case ACTION_FUSION:
          this.affFusion = true;
          break;
        default:
          break;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageParametrage.schemaComptable.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
